import React from "react";
import styled from "styled-components";
import Myinfo from "../ui/Myinfo";
import MyPageButton from "../ui/MyPageButton"

function MyPage () {
    
    return(
        <>
        <Myinfo/>
        <MyPageButton/>
        </>
    );
}
 
export default MyPage